import * as React from "react";
const IconPinterest = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M1.8 32.1c.2 9.3 4.5 18.6 11.8 24.2 2.3 1.7 4.8 2.7 7.4 3.8-1.1-7.1 1.6-14.2 3.1-21.2.2-.7.3-1.5.3-2.3 0-1.1-.4-2.2-.7-3.3-.3-1.8-.1-3.7.7-5.4 1.1-2.3 3.7-4.1 6-3.2 2.1.8 2.9 3.6 2.5 5.8-.4 2.3-1.6 4.3-2.2 6.5-.7 2.2-.6 4.9 1 6.4 1.5 1.4 3.9 1.5 5.8.7 2.8-1.2 4.6-4 5.7-6.8 2-5.2 1.6-11.8-2.5-15.6-1.7-1.7-4.1-2.8-6.7-3.2-4.4-.7-9.2.6-12.3 3.8s-4.5 8.1-3.2 12.3c.4 1.4 1.2 2.8 1.5 4.2s.2 3.2-.8 4.2c-.1.1-.2.2-.4.3s-.5-.1-.7-.2c-1.9-1.2-3.4-3.1-4.3-5.1-2.8-6.1-1.4-13.7 3-18.7s11.5-7.4 18.1-6.5c6.2.8 12.3 4.5 14.9 10.2 1.6 3.4 1.9 7.3 1.3 11-.6 3.8-2.1 7.4-4.6 10.3s-6.1 4.9-9.9 5.1c-3.1.2-6.4-.9-8-3.5-1 5.4-2.9 10.7-5.7 15.4-.1.2 6.4 1.6 7 1.6 7.4.6 15.3-2.3 21.1-6.9 16-12.7 14.3-37-1.5-49C41.3.7 31.6-.5 22 2.9c-2.9 1-5.6 2.7-8.1 4.5-4 3-7.2 6.9-9.3 11.4-2.1 4.1-2.9 8.7-2.8 13.3" />
  </svg>
);
export default IconPinterest;
